// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Components
import NotificationsContent from '../NotificationsContent';
import PopupPanel from '../../../../../components/popupPanel/PopupPanel';
import NotificationsPopupTabbedContent from './NotificationsPopupTabbedContent';

// Constants
import { PopupIds } from '../../../../../components/popupPanel/popupConstants';

const NotificationsPopup = (props) => (
    <PopupPanel {...props} popupId={PopupIds.NOTIFICATIONS} className="NotificationsPopup TabbedPopupPanel">
        <NotificationsContent {...props} ContentComponent={NotificationsPopupTabbedContent} />
    </PopupPanel>
);

NotificationsPopup.propTypes = {
    currentUser: PropTypes.object,
    updateLastCheckedTime: PropTypes.func,
    lastCheckedNotifications: PropTypes.number,
};

export default NotificationsPopup;
